import { z } from "zod";
export const invitationIdParamSchema = z.object({
    invitationId: z.string(),
});
